import { render, staticRenderFns } from "./ChildPhoneImageCell.vue?vue&type=template&id=4885ed7c&"
import script from "./ChildPhoneImageCell.vue?vue&type=script&lang=js&"
export * from "./ChildPhoneImageCell.vue?vue&type=script&lang=js&"
import style0 from "./ChildPhoneImageCell.vue?vue&type=style&index=0&id=4885ed7c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports